import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { EVENING } from "../CONSTANTS";
import { getAvailableAppointmentSlots } from "../networkCalls";
import { ConsultingSlot, ConsultingSlotsType } from "./types";
import { IAppointmentsDataTypeInput } from "../Appointments/AppointmentController";
import { IAppointmentsDataType } from "@/redux/reduxAppointments/appointmentsSlice";

dayjs.extend(utc);
dayjs.extend(timezone);

export function convertAppointmentSlotsToStrings(slots: ConsultingSlotsType[]) {
  return slots.map((slot) => dayjs(slot.start).format("LT"));
}

export function getNextAvailableTime(consultingSlot: ConsultingSlot) {
  const now = dayjs();
  if (consultingSlot === ConsultingSlot.DAY) {
    const afternoonStart = now
      .set("hour", 14)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
    const afternoonEnd = now
      .set("hour", 18)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
    return {
      start: afternoonStart.utc().toISOString(),
      end: afternoonEnd.utc().toISOString(),
    };
  }
  // EVENING or default
  // If current time is between 0:00 and 3:00, nightStart is yesterday 18:00, nightEnd is today 1:00
  // Otherwise, nightStart is today 18:00, nightEnd is tomorrow 1:00
  const hour = now.hour();
  let nightStart, nightEnd;
  if (hour >= 0 && hour <= 3) {
    nightStart = now
      .subtract(1, "day")
      .set("hour", 18)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
    nightEnd = now
      .set("hour", 1)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
  } else {
    nightStart = now
      .set("hour", 18)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
    nightEnd = now
      .add(1, "day")
      .set("hour", 1)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
  }
  return {
    start: nightStart.utc().toISOString(),
    end: nightEnd.utc().toISOString(),
  };
}

export function getAppointmentSlotsAndSetTimes(
  consultingSlot: string,
  setAvailableAppointmentSlots: any,
  setReadableAppointmentTimes: any
) {
  var currentSlot =
    consultingSlot === EVENING ? ConsultingSlot.EVENING : ConsultingSlot.DAY;
  var appointmentStartEndTimes = getNextAvailableTime(currentSlot);

  getAvailableAppointmentSlots(
    appointmentStartEndTimes.start,
    appointmentStartEndTimes.end
  ).then((data) => {
    if (data.length < 1) {
      const currentData = [
        {
          start: appointmentStartEndTimes.end,
          end: dayjs(appointmentStartEndTimes.end)
            .add(5, "minute")
            .toISOString(),
        },
      ];
      setAvailableAppointmentSlots(currentData);
      const readableSlots = convertAppointmentSlotsToStrings(currentData);
      setReadableAppointmentTimes(readableSlots);
    } else {
      setAvailableAppointmentSlots(data);
      const readableSlots = convertAppointmentSlotsToStrings(data);
      setReadableAppointmentTimes(readableSlots);
    }
  });
}
export function formatAppointments(
  rawAppointments: Array<IAppointmentsDataTypeInput>
): Array<IAppointmentsDataType> {
  // Just return the input as is, since all fields are already strings
  return rawAppointments.map((appointment) => ({ ...appointment }));
}
